<span
    class="sb-counter color-secondary"
    tappable
    (click)="onClick.emit($event)"
>
    +{{ count }}
    <span class="codere-icon icon-arrow-right"></span>
</span>
